import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translations from './translations.json';
import {Translations} from './types';

// Transform our format to i18next format
// This will be populated when translations are added
const typedTranslations = translations as Translations;
const resources = Object.entries(typedTranslations).reduce(
  (acc, [key, locales]) => {
    Object.entries(locales || {}).forEach(([locale, value]) => {
      if (!acc[locale]) acc[locale] = {translation: {}};
      acc[locale].translation[key] = value;
    });
    return acc;
  },
  {} as Record<string, {translation: Record<string, string>}>,
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-GB',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
